import React from 'react';
import useI18n from '@i18n';
import BaseGrid from '../../../base/BaseGrid';
import BaseContainer from '../../../base/BaseContainer';
import IconOffer from './images/icon_offer.svg';
import IconLink from './images/icon_link.svg';
import IconAli from './images/icon_ali.svg';
import IconId from './images/icon_id.svg';

const BLOCKS = [
    {
        icon: IconOffer,
        text: 'We work with all offers',
        key: 1,
        alt: 'offer icon',
    },
    {
        icon: IconLink,
        text: 'You can send a few links at once',
        key: 2,
        alt: 'link icon',
    },
    {
        icon: IconAli,
        text: 'We work with the mobile application AliExpress',
        key: 3,
        alt: 'phone icon',
    },
    { icon: IconId, text: 'Support up to 5 subid', key: 4, alt: 'id icon' },
];

const AdvantagesBlock: React.FC = () => {
    const { t } = useI18n('TelegramBot');

    return (
        <div className="flex w-full  bg-[#53acd410]">
            <BaseContainer>
                <h2 className="w-full mx-auto font-medium text-center text-h1 text-brandBlue-500 my-[18px] xs:my-[32px] xs:ml-0 xs:w-full md:text-2xl lg:text-3xl">
                    {t('Advantages of our telegram bot')}
                </h2>
                <BaseGrid container className="flex-wrap">
                    {BLOCKS.map(({ icon, text, key, alt }) => (
                        <BaseGrid key={key} item sm={3} xs={6} initial={12} className="px-[18px]">
                            <div className="flex flex-col items-center w-full my-[8px] last:mb-[32px] xs:my-[16px]">
                                <img src={icon} className="w-[52px] h-[52px] mb-[16px]" alt={alt} />
                                <p className="w-full text-center text-[16px] text-brandBlue-300 xs:w-[200px] sm:w-[auto] md:text-base md:w-[235px] lg:text-lg">
                                    {t(text)}
                                </p>
                            </div>
                        </BaseGrid>
                    ))}
                </BaseGrid>
            </BaseContainer>
        </div>
    );
};

export default AdvantagesBlock;
